'use strict';

// Vue
import Vue from 'vue';

// 3rd party
import moment from 'moment';

// API
import {
  requestUpdateAnswer,
  requestAddAnswer,
  requestAnswer,
  requestUpdateUserResponse,
} from 'api/answers';

// State
const state = {
  authToken: '',
  answers: [],
  allQuestions: [],
};

// Getters
const getters = {
  isTempAuth: state => !!state.authToken,
  answers: state => state.answers,
  allQuestions: state => state.allQuestions,
  startIntakeTimeStamp: state => state.startIntakeTimeStamp,
  savingAnswer: state => state.savingAnswer,
};

// Mutations
const mutations = {
  SET_TOKEN(state, payload) {
    state.authToken = payload.answer_token;
    localStorage.setItem('answer_token', payload.answer_token);
    localStorage.setItem('answer_id', payload.id);
    localStorage.setItem('answerTokenTimestamp', moment().format());
  },

  SET_ANSWERS(state, payload) {
    Vue.set(state, 'answers', payload);
  },

  UPDATE_ANSWER(state, payload) {
    Vue.set(state, 'updateAnswer', payload);
  },

  ALL_QUESTIONS(state, payload) {
    Vue.set(state, 'allQuestions', payload);
  },

  STORE_START_INTAKE_TIME_STAMP(state, payload) {
    const timestamp = payload || moment().format();

    if ( !payload && timestamp ) localStorage.setItem('startIntakeTimeStamp', timestamp);
  },

  REMOVE_START_INTAKE_TIME_STAMP(state) {
    Vue.set(state, 'startIntakeTimeStamp', null);
    localStorage.removeItem('startIntakeTimeStamp');

    const stored = [
      'Who',
      'Location',
      'Complaint',
      'SecondaryComplaint',
    ];

    stored.forEach((item, index) => {
      localStorage.removeItem(`object${stored[index]}`);
    });
  },

  SET_SAVING_ANSWER_STATE(state, payload) {
    Vue.set(state, 'savingAnswer', payload);
  },
};

// Actions
const actions = {

  requestAnswer({ dispatch }, model) {
    return new Promise((resolve, reject) => {
      requestAnswer(model)
        .then(response => {
          localStorage.setItem('singleAnswer', response.data.id);
          dispatch('updateAnswers', response.data || {});
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  requestAddAnswer({ dispatch }, target) {
    return new Promise((resolve, reject) => {
      requestAddAnswer(target.id, target.model)
        .then(response => {
          if ( target.output ) {
            dispatch('allQuestions', target.output);
          }
          dispatch('updateIntakeStatus');
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  requestUpdateAnswer({ dispatch, commit }, target) {
    commit('SET_SAVING_ANSWER_STATE', true);

    return new Promise((resolve, reject) => {
      requestUpdateAnswer(target.id, target.model)
        .then(response => {
          dispatch('updateAnswer', response.data || {});
          commit('SET_SAVING_ANSWER_STATE', false);
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          commit('SET_SAVING_ANSWER_STATE', false);
          reject(error);
        });
    });
  },

  requestUpdateUserResponse({ dispatch }, target) {
    return new Promise((resolve, reject) => {
      requestUpdateUserResponse(target.id, target.model)
        .then(response => {
          dispatch('updateAnswer', response.data || {});
          resolve(response);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  updateAnswers({ commit }, data) {
    if (data.answer_token) {
      commit('SET_TOKEN', data);
    }
    commit('SET_ANSWERS', data);
  },

  addAnswer({ commit }, data) {
    commit('ADD_ANSWER', data);
  },

  allQuestions({ commit }, data) {
    commit('ALL_QUESTIONS', data);
  },

  updateAnswer({ commit }, data) {
    commit('UPDATE_ANSWER', data);
  },

  checkIntakeStatus({ commit }) {
    const timestamp = localStorage.getItem('startIntakeTimeStamp');

    if ( timestamp && moment().diff(moment(timestamp), 'minutes') < 30 ) {
      // Save current timestamp from local storage to state
      commit('STORE_START_INTAKE_TIME_STAMP', timestamp);
    } else {
      commit('REMOVE_START_INTAKE_TIME_STAMP');
    }
  },

  updateIntakeStatus({ commit }) {
    const timestamp = localStorage.getItem('startIntakeTimeStamp');

    if ( !timestamp ) commit('STORE_START_INTAKE_TIME_STAMP');
    if ( moment().diff(moment(timestamp), 'minutes') > 30 ) commit('REMOVE_START_INTAKE_TIME_STAMP');
  },
};

// Export
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/answers.js